import { IconPlus } from '../../../../shared/components/icons/IconPlus'
import React from 'react'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { AddTrademarkRegistrationModal } from '../../../../lib/widgets/add-trademark-registration-modal/AddTrademarkRegistrationModal'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

interface CountryCellProps {
  project: number
  trademark: {
    id: number
    name: string
  }
  is_registered: boolean
  country: {
    id: number
    code: string
    name: string | null
  }
}

export const CountryCell = ({ project, trademark, is_registered, country }: CountryCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className={'flex flex-col gap-[4px]'}>
      <div className={'flex gap-[4px]'}>
        <Tooltip title={country.name}>
          <div className='relative h-[30px] w-[30px] overflow-hidden rounded-full border-2 border-aqua/[.1]'>
            <span
              className={`fi fis fi-${country.code} absolute top-0 left-0 block !h-[26px] !w-[26px]`}
            />
          </div>
        </Tooltip>
        {!is_registered && (
          <Tooltip title={t('pages.trademarkInfringements.registrationMissingTooltip')}>
            <div className='relative h-[30px] w-[30px] overflow-hidden rounded-full border-2 border-aqua/[.1] bg-[#FF5778]'>
              <span
                className={
                  'absolute top-0 left-0 flex !h-[26px] !w-[26px] select-none items-center justify-center text-white'
                }
              >
                TM
              </span>
            </div>
          </Tooltip>
        )}
      </div>
      {!is_registered && (
        <button
          className={
            'row-hover-visible flex w-fit cursor-pointer items-center gap-[4px] whitespace-nowrap text-[12px] leading-[16px] text-focus'
          }
          onClick={() =>
            dispatch(
              setModal({
                children: (
                  <AddTrademarkRegistrationModal
                    data={{
                      project_id: project,
                      trademark_id: trademark.id,
                      country_id: country.id,
                    }}
                  />
                ),
              }),
            )
          }
        >
          <IconPlus className={'w-[10px]'} color={'#0E63D8'} />
          {t('pages.trademarkInfringements.addRegistration')}
        </button>
      )}
    </div>
  )
}
